import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames/bind';
import HubspotForm from 'components/shared/hubspot-form';
import { FORM_IDS } from 'constants/form';
import { BUTTON_THEMES } from 'constants/button';

import Heading from 'components/shared/heading';

import styles from './hero-with-subscription.module.scss';

const cx = classNames.bind(styles);

const HeroWithSubscription = ({ title, description = null }) => (
  <section className={cx('wrapper')}>
    <div className={cx('container', 'inner')}>
      <div className={cx('head')}>
        <Heading className={cx('title')} size="xl">
          {title}
        </Heading>
        {description && <p className={cx('description')}>{description}</p>}
      </div>

      <div className={cx('form')}>
        <HubspotForm
          targetId="hubspotHeroWithSubscribeForm"
          formId={FORM_IDS.SUBSCRIBE}
          buttonTheme={BUTTON_THEMES.ACCENT_PRIMARY}
        />
      </div>
    </div>
  </section>
);

HeroWithSubscription.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};


export default HeroWithSubscription;
